import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth';
import router from './router.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // constants
    rating_items: [100,90,83.33,80,75,70,66.67,60,50,40,33.33,30,25,20,16.66,14.28,12.5,11.11,10,5,0,-5,-10,-11.11,-12.5,-14.28,-16.66,-20,-25,-33.33,-30,-40,-50,-60,-66.67,-70,-75,-80,-83.33,-90,-100],
    // list of rules in all languages
    HTMLSystemRules : [],

    token: null,
    isLogged: false,
    user: null,
    axios_config: null,
    feedback : null,
    countdown : {
      count: -1,
      id: -1,
      max: 1800
    },
    
    // language data
    language_list: null,
    lang_primary_tmp: null,
    lang_secondary_tmp: null, // for translation
    lang_primary: null,
    lang_secondary: null, // for translation
    rule_index: null,
    
    // data lists
    full_content1: [],
    full_content24 : [],
    full_content567 : [],
    full_content8: [],
    full_content11: [],
    full_contentUni : [],
    ratings: [], // ratings in types 2-4
    files: [], // files in types 8...
    rules_globals: [], // list of rules in type 11
    
    // events support
    refresh1: false,
    refresh2: false,
    canDelete1: false,
    canDelete2: false,
    languageChanged: false,
    preparedforSave: false,
    showHelpEvent: false,
    showAnswerEvent: false,
    checkAnswerEvent: false,
    checkRatingEvent: false,
    tryAgainEvent: false,
    breadcrumbsChange : false,
    saveBeforeDelete1 : false,
    saveBeforeDelete2 : false,

    // answers
    answer : null,
        
    // events
    initData1: false,
    initData2: false,
    changedStore1 : false,
    changedStore2 : false,    
    addElement: false,
    deleteElement: 0,

    // status
    fakes: false,

    collapses: {
      a : false,
      b : false,
      c : false,
      d : false,
      e : false
    },

    // programs settings
    programElements : {
      assignment:  {
        show: true,
        collapse : true
      },
      files: {
        show: true,
        collapse : false
      },
      testCases: {
        show: true,
        collapse : false
      },
      filesToKeep : { // files as files in program, sql insert files
        show: true,
        collapse : false
      },
      configFiles: { // get from server on create type
        show: true,
        collapse : false
      },
      help: { 
        show: true,
        collapse : false
      }
    },
    programExtension : 'eee',
    editorType: ''
  },
//*********************************************************************** */
//*********************************************************************** */
  mutations: {
    cleanData(state) {
      state.full_content1 = []
      state.full_content24 = []
      state.full_content11 = []
      state.full_content567 = []
      state.full_content8 = []
      state.full_contentUni = []
    },
    //*********************************************************************** */
    setUserData(state, userData) {
      state.user = userData
      state.cleanData
    },
    //*********************************************************************** */
    setConfig(state, data) {
      state.axios_config = {
        headers: {
          Authorization: 'Bearer ' + data
        }
      }
      state.token = data    
      state.isLogged = true
    },
    //*********************************************************************** */
    logout(state) {
      state.user = null
      state.isLogged = false
      state.axios_config = null
      state.token = null
      localStorage.clear()
    },
    //*********************************************************************** */
    setFeedback(state, data) {
      // if (data)
       state.feedback = data
    },
    //***********************************************************************
    setLanguageList(state, data) {
      state.language_list = data
    },
    //***********************************************************************
    setLangPrimary(state, data) {
      state.lang_primary = data
    },
    //***********************************************************************
    setLangSecondary(state, data) {
      state.lang_secondary = data
    },
    //***********************************************************************
    setLangPrimaryTmp(state, data) {
      state.lang_primary_tmp = data
    },
    //***********************************************************************
    setLangSecondaryTmp(state, data) {
      state.lang_secondary_tmp = data
    },
    //***********************************************************************
    setLogedOff(state) {
      state.isLogged = false
    },
    //***********************************************************************
    setContent1(state, data) {
      state.full_content1["l"+String(data.lang_id)] = data.content
    },
    //***********************************************************************
    setContent24(state, data) {
      state.full_content24["l"+String(data.lang_id)] = data.content
    },       
    //***********************************************************************
    setContent11(state, data) {
      state.full_content11["l"+String(data.lang_id)] = data.content
    },    
    //***********************************************************************
    setContent567(state, data) {
      state.full_content567["l"+String(data.lang_id)] = data.content
    },
    //***********************************************************************
    setContent8(state, data) {
      state.full_content8["l"+String(data.lang_id)] = data.content
    },    
    //***********************************************************************
    setContentUni(state, data) {
      state.full_contentUni["l"+String(data.lang_id)] = data.content
    },    
    //***********************************************************************
    setCanDelete1(state, data) {
      state.canDelete1 = data
    },    
    //***********************************************************************
    setCanDelete2(state, data) {
      state.canDelete2 = data
    },    
    //***********************************************************************
    setRefresh1(state, data) {
      state.refresh1 = data
      if (state.refresh1 && state.refresh2) 
        state.preparedforSave = true
    },
    //***********************************************************************
    setRefresh2(state, data) {
      state.refresh2 = data
      if (state.refresh1 && state.refresh2) 
        state.preparedforSave = true
    },    
    //***********************************************************************
    setLanguageChanged(state, data) {
      state.languageChanged = data
    },
    //***********************************************************************
    setInitData1(state, data) {
      state.initData1 = data
    },
    //***********************************************************************
    setInitData2(state, data) {
      state.initData2 = data
    },
    //***********************************************************************
    setSaveBeforeDelete1(state, data) {
      state.saveBeforeDelete1 = data
    },
    //***********************************************************************
    setSaveBeforeDelete2(state, data) {
      state.saveBeforeDelete2 = data
    },
    //***********************************************************************
    setAddElement(state, data) {
      state.addElement = data
    },
    //***********************************************************************
    setChangedStore1(state, data) {
      state.changedStore1 = data
    },
    //***********************************************************************
    setChangedStore2(state, data) {
      state.changedStore2 = data
    },
    //***********************************************************************
    setDeleteElement(state, data) {
      state.deleteElement = data
    },
    setProgramExtension(state,data) {
      state.programExtension = data
    },
    setEditorType(state,data) {
      state.editorType = data
    },
    setCountdown(state, data) {
      if (data == 0) 
        state.countdown = { id: -1, count: -100, max: 0}
       else
        state.countdown = { id: data, count: 1800, max: 1800}
    },
    downCountdown(state) {
      state.countdown.count--;
    },
    //***********************************************************************
    setHTMLSystemRules(state, data) { // set '' for all languages
      state.HTMLSystemRules = []
      for(let i = 0; i < state.language_list.length; i++) {
        state.HTMLSystemRules["l"+String(state.language_list[i].id)] = []
      }

      for(let i = 0; i < data.list.length; i++) {
        state.HTMLSystemRules["l"+String(data.list[i].lang_id)] = data.list[i].rules
      }

    },
    //***********************************************************************
    prepareContent1(state) { // set '' for all languages
      state.full_content1 = []
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content1["l"+String(state.language_list[i].id)] = ''        
      }
    },
    //***********************************************************************
    addAnswertoList24(state)    {
      state.ratings.push(0)
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)].answer_list.push({answer: '', feedback: ''})
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },    
      //***********************************************************************
      addRuletoList11(state, data)    {
        state.rules_globals.push(data.id)

        var start = 0

        for(let i = 0; i < state.language_list.length; i++) {
          var con = state.HTMLSystemRules["l"+String(state.language_list[i].id)][data.index]

          var c = con.text
          var res = []
          while (c.indexOf('####') > -1 || (c.indexOf('$$$$') > -1)) {
              // take first
              if (c.indexOf('####') > -1 && c.indexOf('$$$$') > -1) {
                    if (c.indexOf('####') < c.indexOf('$$$$')) {
                        start = c.indexOf('####')
                        // ## first
                        if (start == 0) {
                            res.push({ type: 'n', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 'n', text: ''})
                            c = c.substring(start+4)
                        }
                    } else {
                        // $$ first
                        start = c.indexOf('$$$$')
                        if (start == 0) {
                            res.push({ type: 't', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 't', text: ''})
                            c = c.substring(start+4)
                        }
                    }
              } else {
                  // ####
                  if (c.indexOf('####') > -1) {
                        start = c.indexOf('####')
                        // ## first
                        if (start == 0) {
                            res.push({ type: 'n', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 'n', text: ''})
                            c = c.substring(start+4)
                        }
                  }
                  // $$$$
                    if (c.indexOf('$$$$') > -1) {
                        start = c.indexOf('$$$$')
                        // ## first
                        if (start == 0) {
                            res.push({ type: 't', text: ''})
                            c = c.substring(4)
                        } else {
                            res.push({ type: 'c', text: c.substring(0,start)})
                            res.push({ type: 't', text: ''})
                            c = c.substring(start+4)
                        }
                  }
              }
          }
          if (c.length > 0) res.push( { type: 'c', text: c})
          let result = res
          state.full_content11["l"+String(state.language_list[i].id)].rules_list.push({rule_id: data.id, content: result, description : ''})
        }
        state.changedStore1 = true
        state.changedStore2 = true
      },  
    //***********************************************************************
    addFiletoList(state,data) {
      switch (data) {
        case 1: state.files.files.push('file' + (state.files.files.length+1)+'.' + state.programExtension)
                for(let i = 0; i < state.language_list.length; i++) {
                  state.full_content8["l"+String(state.language_list[i].id)].files.push({rContent: '', aContent: ''})
                }
                break
        case 2: state.files.filesToKeep.push('keep' + (state.files.filesToKeep.length+1))
                for(let i = 0; i < state.language_list.length; i++) {
                  state.full_content8["l"+String(state.language_list[i].id)].filesToKeep.push('')
                }
                break
        case 3: state.files.configFiles.push('config' + (state.files.configFiles.length+1))
                for(let i = 0; i < state.language_list.length; i++) {
                  state.full_content8["l"+String(state.language_list[i].id)].configFiles.push('')
                }
                break  
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //***********************************************************************
    prepare24(state) {
      // rating
      state.ratings = [100]
      state.full_content24 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)] = {content:'', help:'', answer_list:[{answer: '', feedback: ''}]}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepare11(state) {
      // rating
      state.ratings = []
      state.full_content11 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content11["l"+String(state.language_list[i].id)] = { title: '', 
        assignment: '',
        requestedFile: '',
        authorsFile: '',
        help: '',
        rules_list: []}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //***********************************************************************
    prepare56(state) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', help:'', fakes:[]}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepare7(state) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', code:'', help:''}
      }
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepareUni(state, cType) {
      state.full_contentUni = []

      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        if (cType == 'default') { state.full_contentUni["l"+String(state.language_list[i].id)] = { name : ''} }
        if (cType == 'course') { state.full_contentUni["l"+String(state.language_list[i].id)] = { name : '', description: '', detail: ''} }
      }

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    prepare8(state, data) {
      // visible and invisible parts
      state.programElements = data.visibility
      state.full_content8 = []

      if (data.type == 10) {
        state.files = {
          files : [ 'answer.sql'],
          filesToKeep: ['keep1'],
          configFiles: ['vpl_run.sh','vpl_debug.sh','vpl_evaluate.sh', 'createTables.sql', 'showResult.sql','correctAnswer.sql', 'dataset1.sql', 'dataset2.sql', 'dataset3.sql']
        }
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content8["l"+String(state.language_list[i].id)] = 
            {
                title: '',
                assignment: '',
                files: [{
                            rContent: '',
                            aContent : ''
                        }
                ],                     
                testCases: '',
                filesToKeep: [''],
                configFiles: ['','','','','','','','',''],
                help: ''                    
            }
        } 

      } else {
        state.files = {
          files : [ 'file1.' + data.extension ],
          filesToKeep: ['keep1'],
          configFiles: ['vpl_run.sh','vpl_debug.sh','vpl_evaluate.sh']
        }
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content8["l"+String(state.language_list[i].id)] = 
            {
                title: '',
                assignment: '',
                files: [{
                            rContent: '',
                            aContent : ''
                        }
                ],                     
                testCases: '',
                filesToKeep: [''],
                configFiles: ['','',''],
                help: ''                    
            }
        } 
      }
 
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //***********************************************************************
    setFakes(state, data) {
      state.fakes = data
    },
    //***********************************************************************
    setPreparedforSave(state, data) {
      state.preparedforSave = data
    },
    //***********************************************************************
    setRatings(state,data) {
      state.ratings = data
    },
    //***********************************************************************
    setRulesGlobals(state,data) {
      state.rules_globals = data
    },    //***********************************************************************
    setFiles(state,data) {
      state.files = data
      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    setProgramElements(state, data) {
      state.programElements = data
    },
    //***********************************************************************
    setCollapses(state) {
      state.collapses = {a:true, b:false, c: false, d:false, e:false}
    },
    changeCollapse(state, data) {
      switch (data) {
        case 0 : state.collapses.a = !state.collapses.a
                 break
        case 1 : state.collapses.b = !state.collapses.b
                 break
        case 2 : state.collapses.c = !state.collapses.c
                 break
        case 3 : state.collapses.d = !state.collapses.d
                 break
        case 4 : state.collapses.e = !state.collapses.e
                 break
      }
    },
    setShowHelpEvent(state, data) {
      state.showHelpEvent = data
    },
    setShowAnswerEvent(state, data) {
      state.showAnswerEvent = data
    },
    setCheckAnswerEvent(state, data) {
      state.checkAnswerEvent = data
    },
    setCheckRatingEvent(state, data) {
      state.checkRatingEvent = data
    },
    setTryAgainEvent(state, data) {
      state.tryAgainEvent = data
    },
    setAnswer(state,data) {
      state.answer = data
    },
    setBcChange(state, data) {
      state.breadcrumbsChange = data
    },
    setRuleIndex(state,data) {
      state.rule_index = data
    }

  },

//*********************************************************************** */
//*********************************************************************** */
  actions: {
    //*********************************************************************** */
    login( {dispatch, commit, state}, authData ) {
      commit('setFeedback', null)
      axios.post('/oauth/token', authData)
      .then(res => {        
        // TOKEN TO LOCAL STORAGE
        localStorage.setItem('token', res.data.access_token) 
        commit('setConfig', res.data.access_token)
        axios.get('/get-full-user-parameters', state.axios_config)
        .then(res => {
            // set data to store
            commit('setUserData', res.data)     
            localStorage.setItem('role_id', res.data.role_id)
            localStorage.setItem('user_id', res.data.user_id)
         //   setTimeout(() => {
              dispatch('loadLanguageData')              
          //  }, 500); 
            router.replace({name : 'dashboard'})
        })
        .catch(error => {
          commit('setFeedback', error.response.data.message)    
        })
      })
      .catch(() => {
        commit('setFeedback', "Access denied.")
      })
    },
    //*********************************************************************** */
    tryAutologin({dispatch, commit, state}) {
      commit('setFeedback', null)
      state.token = localStorage.getItem('token')
      if (state.token) {
        commit('setConfig', state.token)
        axios.get('/get-full-user-parameters', state.axios_config)
        .then(res => {
            // set data to store
            commit('setUserData', res.data) 
           // setTimeout(() => {
              dispatch('loadLanguageData')              
           // }, 500); 
        })
        .catch(() => {
          commit('logout')
          router.replace({name : 'login'})
        })
      } else {
        router.replace({name : 'login'})        
      }
    },
    //*********************************************************************** */
    logout({commit}) {
      commit('logout')
      router.replace({name : 'welcome'})
    },
    //*********************************************************************** */
    loadLanguageData( {commit, state}) {
      commit('setFeedback', null)
      axios.get('/languages')
        .then(res => {            
            // set data to store
            commit('setLanguageList', res.data) 
            // primary and secondary languages for translation
            var prim = res.data[0]
            var sec = res.data[1]
            for(let i = 1; i < res.data.length; i++) {
              if (res.data[i].id == state.user.lang_id) sec = res.data[i]
            }
            commit('setLangPrimary', prim)
            commit('setLangSecondary', sec)
            // add list of languages for admin creation 

            // translations for secondary lang
        })
        .catch((error) => {
          commit('setFeedback', error)
        })
      },
      setCountDownRefresh({commit, state}) {
        // write to db
        const data = {
          task_id : state.countdown.id
        }
        axios.post('/refresh-lock', data, state.axios_config)
        .then(() => {        

          // setcountdown
          state.countdown.count = state.countdown.max
        })
        .catch(error => {
          // eslint-disable-next-line
          console.log(error.message)
          var str = error.message            
          var _err = str.substring(str.length - 3, str.length)
          if (_err == 400) commit('setFeedback', error.message)   
          if (_err == 401) commit('setFeedback', 'You do not have permissions to access to this section.')
          if (_err == 402) commit('setFeedback', 'The task  was deleted.')
          if (_err == 403) commit('setFeedback', 'Your task has been taken over by another user.')
           
          state.countdown.count = -1
        })        
      },
    //*********************************************************************** */
    deleteAnswerinList({state},data) {
      state.ratings.splice(data,1)
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)].answer_list.splice(data,1)
      }      
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //*********************************************************************** */
    deleteRuleinList({state},data) {
      state.rules_globals.splice(data,1)
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content11["l"+String(state.language_list[i].id)].rules_list.splice(data,1)
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //*********************************************************************** */
    deleteElementinList({state},data) {
      switch (data.tab) {
        case 1 :  state.files.files.splice(data.index,1)
                  for(let i = 0; i < state.language_list.length; i++) {
                    state.full_content8["l"+String(state.language_list[i].id)].files.splice(data.index,1)
                  } 
                  break
        case 2 :  state.files.filesToKeep.splice(data.index,1)
                  for(let i = 0; i < state.language_list.length; i++) {
                    state.full_content8["l"+String(state.language_list[i].id)].filesToKeep.splice(data.index,1)
                  } 
                  break
        case 3 :  state.files.configFiles.splice(data.index,1)
                  for(let i = 0; i < state.language_list.length; i++) {
                    state.full_content8["l"+String(state.language_list[i].id)].configFiles.splice(data.index,1)
                  } 
                  break
      }
      state.changedStore1 = true
      state.changedStore2 = true
    },

    
    //***********************************************************************
    setFullContent24({state}, data) {
      // rating
      state.ratings = data.globals.ratings
      
      state.full_content24 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content24["l"+String(state.language_list[i].id)] = {content:'', help:'', answer_list:[{answer: '', feedback: ''}]}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {
       
        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)
        

          state.full_content24["l"+String(data.content_list[i].lang_id)] = {
            content: mycontent.content, 
            help: mycontent.help, 
            answer_list: mycontent.answer_list 
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //***********************************************************************
    setFullContent11({state}, data) {
      // rating
      state.rules_globals = data.globals.globals

      state.full_content11 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content11["l"+String(state.language_list[i].id)] = { title: '', 
                                                                        assignment: '',
                                                                        requestedFile: '',
                                                                        authorsFile: '',
                                                                        help: '',
                                                                        rules_list: []}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {
       
        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)
        

          state.full_content11["l"+String(data.content_list[i].lang_id)] = {
            title: mycontent.title, 
            assignment: mycontent.assignment, 
            requestedFile: mycontent.requestedFile, 
            authorsFile: mycontent.authorsFile, 
            help: mycontent.help, 
            rules_list: mycontent.rules_list 
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },



    //***********************************************************************

    setFullContent56({state}, data) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', help:'', fakes:[]}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {

        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)

          state.full_content567["l"+String(data.content_list[i].lang_id)] = {
            content: mycontent.content, 
            help: mycontent.help, 
            fakes: mycontent.fakes 
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },
    //************************************************************* */
    setFullContent7({state}, data) {
      state.full_content567 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content567["l"+String(state.language_list[i].id)] = {content:'', code:'', help:''}
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {
        const mycontent = JSON.parse(data.content_list[i].content)
        
        if (data.content_list[i].content.length>1) {
          state.full_content567["l"+String(data.content_list[i].lang_id)] = {
            content: mycontent.content, 
            code: mycontent.code, 
            help: mycontent.help
          }
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //************************************************************* */
    setFullContentUni({commit, state}, data) {
      commit('prepareUni',data.cType)
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {
        if (data.cType == 'default') { 
           state.full_contentUni["l"+String(data.content_list[i].lang_id)] = { name: data.content_list[i].name } 
          }
        if (data.cType == 'course') { 
          state.full_contentUni["l"+String(data.content_list[i].lang_id)] = { 
                                                                              name: data.content_list[i].name, 
                                                                              description: data.content_list[i].description, 
                                                                              detail: data.content_list[i].detail 
                                                                            } 
          }
 
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },    
    //********************************************************************* */
    setFullContent8({state}, data) {
      // visible and invisible parts
      state.programElements = data.settings
      
      // names of files
      state.files = data.globals.files

      state.full_content8 = []
      // content in all languages
      for(let i = 0; i < state.language_list.length; i++) {
        state.full_content8["l"+String(state.language_list[i].id)] = 
          {
              title: '',
              assignment: '',
              files: [{
                          rContent: '',
                          aContent : ''
                      }
              ],                     
              testCases: '',
              filesToKeep: [],
              configFiles: [],
              help: ''                    
          }
      }
      // existing content
      for(let i = 0; i < data.content_list.length; i++) {

        if (data.content_list[i].content.length>1) {
          const mycontent = JSON.parse(data.content_list[i].content)

          state.full_content8["l"+String(data.content_list[i].lang_id)] = mycontent
        }
      }  

      // refresh content on page
      state.changedStore1 = true
      state.changedStore2 = true
    },   
    setActiveCategory(state, data) {
      let record = {
        activeCategory : data,
        activeArea : 0,
        activeCourse : 0,
        activeChapter : 0,
        activeLesson : 0,
        activeMicro : 0
      }
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveCourseDetails(getters,data) {
      let rr = {
        activeCategory : {id : data.category.id, name: data.category.name},
        activeArea : {id : data.area.id, name: data.area.name},
        activeCourse : {id : data.course.id, name: data.course.name},
        activeChapter : 0,
        activeLesson : 0,
        activeMicro : 0
      }
      localStorage.setItem('position', JSON.stringify(rr))      
    },
    setActiveArea(getters,data) {
      let rr = JSON.parse(localStorage.getItem('position'))
      rr.activeArea = { id: data.id, name: data.name}
      rr.activeCourse = 0
      rr.activeChapter = 0
      rr.activeLesson = 0
      rr.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(rr))      
    },
    setActiveCourse(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeCourse = { id: data.id, name: data.name}
      record.activeChapter = 0
      record.activeLesson = 0
      record.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveChapter(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeChapter = { id: data.id, name: data.name}
      record.activeLesson = 0
      record.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveLesson(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeLesson = { id: data.id, name: data.name}
      record.activeMicro = 0
      localStorage.setItem('position', JSON.stringify(record))
    },
    setActiveMicro(getters, data) {
      var record = JSON.parse(localStorage.getItem('position'))
      record.activeMicro = { id: data.id, name: data.name}
      localStorage.setItem('position', JSON.stringify(record))
    }
  },
//*********************************************************************** */
//*********************************************************************** */
  getters: {
    user (state) {
      return state.user
    },
    //*********************************************************************** */
    getAxiosConfig (state) {
      return state.axios_config
    },   
     //*********************************************************************** */
    getFeedback (state) {
      return state.feedback
    },
    //*********************************************************************** */
    isLogged(state) {   
      return state.isLogged
    },
    //*********************************************************************** */
      isAdmin(state) {
        if(state.user) {
          return state.user.role_id == 2
        } else {
          return false
        }
      },
    //*********************************************************************** */
    getLanguageList(state) {
      return state.language_list
    },
    //*********************************************************************** */
    getLanguagePrimary(state) {
      if (state.lang_primary)
        return state.lang_primary
      else
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //*********************************************************************** */
    getLanguageSecondary(state) {
      if (state.lang_secondary)
        return state.lang_secondary
      else 
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //*********************************************************************** */
    getLanguagePrimaryTmp(state) {
      if (state.lang_primary_tmp)
        return state.lang_primary_tmp
      else
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //*********************************************************************** */
    getLanguageSecondaryTmp(state) {
      if (state.lang_secondary_tmp)
        return state.lang_secondary_tmp
      else 
        return {id: 1, name: 'english', shortcut: 'en'}
    },
    //***********************************************************************
    getContent1: (state) => (lang_id) => {
        return state.full_content1["l"+String(lang_id)]
    },
    //***********************************************************************
    getContent24: (state) => (lang_id) => {
        return state.full_content24["l"+String(lang_id)]
    },
    //***********************************************************************
    getContent11: (state) => (lang_id) => {
      return state.full_content11["l"+String(lang_id)]
    },    
    //***********************************************************************
    getContent567: (state) => (lang_id) => {
      return state.full_content567["l"+String(lang_id)]
    },    
    //***********************************************************************
    getContent8: (state) => (lang_id) => {
      return state.full_content8["l"+String(lang_id)]
    },    
    //***********************************************************************
    getContentUni: (state) => (lang_id) => {
      return state.full_contentUni["l"+String(lang_id)]
    },    
    //***********************************************************************
    getAllContent1 (state) {
      return state.full_content1
    },
    //***********************************************************************
    getAllContent24 (state) {
      return state.full_content24
    },
    //***********************************************************************
    getAllContent11 (state) {
      return state.full_content11
    },
    //***********************************************************************
    getAllContent567 (state) {
      return state.full_content567
    },    
    //***********************************************************************
    getAllContent8 (state) {
      return state.full_content8
    },
    //***********************************************************************
    getAllContentUni (state) {
      return state.full_contentUni
    },
    //*********************************************************************** */
    getRefresh1(state) {
      return state.refresh1
    },
    //*********************************************************************** */
    getRefresh2(state) {
      return state.refresh2
    },    
    //*********************************************************************** */
    getInitData1(state) {
      return state.initData1
    },
    //*********************************************************************** */
    getInitData2(state) {
      return state.initData2
    },
    //*********************************************************************** */
    getChangedStore1(state) {
      return state.changedStore1
    },
    //*********************************************************************** */
    getChangedStore2(state) {
      return state.changedStore2
    },
    //*********************************************************************** */
    getAddElement(state) {
      return state.addElement
    },
    //*********************************************************************** */
    getDeleteElement(state) {
      return state.deleteElement
    },
    //*********************************************************************** */
    getLanguageChanged(state) {
      return state.languageChanged
    },
    //*********************************************************************** */
    getPreparedforSave(state) {
      return !(state.refresh1 || state.refresh2)    
    },
    //*********************************************************************** */
    getRatingItems(state) {
      return state.rating_items
    },
    //*********************************************************************** */
    getRatings(state) {
      return state.ratings
    },
    //*********************************************************************** */
    getFiles(state) {
      return state.files
    },
    //***********************************************************************
    missingData(state) {
      return (state.user == null || state.language_list == null)
    },
    //***********************************************************************
    getFakes(state) {
      return state.fakes
    },
    //********************************************************************** */
    getProgramElements(state) {
      return state.programElements
    },
    //********************************************************************** */
    getCollapses(state) {
      return state.collapses
    },
    //********************************************************************** */
    getShowHelpEvent(state) {
      return state.showHelpEvent
    },
    getShowAnswerEvent(state) {
      return state.showAnswerEvent
    },
    getCheckAnswerEvent(state) {
      return state.checkAnswerEvent
    },
    getCheckRatingEvent(state) {
      return state.checkRatingEvent
    },
    getTryAgainEvent(state) {
      return state.tryAgainEvent
    },
    getAnswer(state) {
      return state.answer
    },
    getBcChange(state) {
      return state.breadcrumbsChange
    },
    getHTMLSystemRules(state) {
      return state.HTMLSystemRules
    },
    getRulesGlobals(state) {
      return state.rules_globals
    },
    getRuleIndex(state) {
      return state.rule_index
    },
      //************************************************************ */
/*      parseRules(state, content) {        
        var c = content.text
        var res = []
        var start = 0
        while (c.indexOf('####') > -1 || (c.indexOf('$$$$') > -1)) {
            // take first
            if (c.indexOf('####') > -1 && c.indexOf('$$$$') > -1) {
                  if (c.indexOf('####') < c.indexOf('$$$$')) {
                      start = c.indexOf('####')
                      // ## first
                      if (start == 0) {
                          res.push({ type: 'n', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 'n', text: ''})
                          c = c.substring(start+4)
                      }
                  } else {
                      // $$ first
                      start = c.indexOf('$$$$')
                      if (start == 0) {
                          res.push({ type: 't', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 't', text: ''})
                          c = c.substring(start+4)
                      }
                  }
            } else {
                // ####
                if (c.indexOf('####') > -1) {
                      start = c.indexOf('####')
                      // ## first
                      if (start == 0) {
                          res.push({ type: 'n', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 'n', text: ''})
                          c = c.substring(start+4)
                      }
                }
                // $$$$
                  if (c.indexOf('$$$$') > -1) {
                      start = c.indexOf('$$$$')
                      // ## first
                      if (start == 0) {
                          res.push({ type: 't', text: ''})
                          c = c.substring(4)
                      } else {
                          res.push({ type: 'c', text: c.substring(0,start)})
                          res.push({ type: 't', text: ''})
                          c = c.substring(start+4)
                      }
                }
            }
        }
        if (c.length > 0) res.push( { type: 'c', text: c})
        return res
      },
*/    //***********************************************************************
    getCanDelete1(state) {
      return state.canDelete1
    },    
    //***********************************************************************
    getCanDelete2(state) {
      return state.canDelete2
    },
    //***********************************************************************
    getSaveBeforeDelete1(state) {
      return state.saveBeforeDelete1 
    },
    //***********************************************************************
    getSaveBeforeDelete2(state) {
      return state.saveBeforeDelete2
    },
    getUserID() {
      return localStorage.getItem('user_id')
    },
    getCountdown(state) {
      return state.countdown.count
    },
    getEditorType(state) {
      return state.editorType
    }

    

    
}
})